import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SectionHeading from "@/components/SectionHeading";
import Gallery from "@/components/Gallery";
import HeroSection from "@/components/HeroSection";

const QuartzPulti = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <HeroSection
          title="Quartz pulti"
          subtitle="Kvarčni pulti za moderen slog"
          imageSrc="/placeholder.svg"
          primaryButtonText="Zahtevaj ponudbo"
          primaryButtonLink="/kontakt"
        />
        
        <div className="container-custom mx-auto py-16">
          <SectionHeading
            title="Quartz pulti"
            subtitle="Kvarčni pulti za moderen slog"
          />
          
          <div className="mt-8 prose prose-lg max-w-none">
            <p>
              Kvarčni pulti združujejo naravno lepoto kremena z najnovejšimi tehnologijami proizvodnje.
              Rezultat je izjemno trpežna, neporozna površina, ki ne zahteva posebnega vzdrževanja in je na voljo v širokem spektru barv in vzorcev.
            </p>
          </div>
          
          <Gallery
            images={[
              { src: "/placeholder.svg", alt: "Quartz pulti 1" },
              { src: "/placeholder.svg", alt: "Quartz pulti 2" },
              { src: "/placeholder.svg", alt: "Quartz pulti 3" },
              { src: "/placeholder.svg", alt: "Quartz pulti 4" },
            ]}
          />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default QuartzPulti;